/**
 * ============================================================================
 * #CUSTOM: Custom JavaScript for Theme Modifications
 * ============================================================================
 * FILE: assets/custom.js
 * 
 * This file contains all custom JavaScript for theme modifications.
 * It will NOT be overwritten during Motion theme updates.
 * 
 * ⚠️ IMPORTANT FOR THEME UPDATES:
 * After updating Motion theme, verify that layout/theme.liquid still includes:
 * {{ 'custom.js' | asset_url | script_tag }}
 * 
 * CREATED: December 2025
 * LAST MODIFIED: December 2025
 * ============================================================================
 */



/**
 * ============================================================================
 * #CUSTOM: Custom JavaScript for Theme Modifications
 * ============================================================================
 * FILE: assets/custom.js
 * 
 * This file contains all custom JavaScript for theme modifications.
 * It will NOT be overwritten during Motion theme updates.
 * 
 * ⚠️ IMPORTANT FOR THEME UPDATES:
 * After updating Motion theme, verify that layout/theme.liquid still includes:
 * {{ 'custom.js' | asset_url | script_tag }}
 * 
 * CREATED: December 2025
 * LAST MODIFIED: December 2025
 * ============================================================================
 */

/**
 * Custom Name Fields - Second Line Toggle
 * 
 * PURPOSE:
 * Shows/hides the second custom name field based on product variant selection.
 * When "Two Lines of Embroidery" variant is selected, second field appears.
 * When "Single Line of Embroidery" variant is selected, second field is hidden.
 * 
 * WORKS WITH:
 * - Radio buttons (image swatches, color swatches, text buttons)
 * - Dropdown selects
 * - Any variant selector type
 * 
 * DEPENDENCIES:
 * 1. Product must have variants with "Two Lines" in the value
 * 2. snippets/product-form.liquid must contain the custom_name2 block with class "custom-name-2-wrapper"
 * 3. sections/main-product.liquid schema must include the custom_name2 block definition
 * 4. This script file must be loaded in theme.liquid
 * 
 * CUSTOMIZATIONS REQUIRED:
 * - snippets/product-form.liquid: Added custom_name and custom_name2 blocks
 * - sections/main-product.liquid: Added custom_name2 block to schema
 * - snippets/custom-product-form-li.liquid: Renders the actual input fields
 * 
 * VARIANT PRICING:
 * - Single Line variant: Base price
 * - Two Lines variant: Base price + $5.00
 * 
 * Created December 4th 2025
 * Last Updated December 4th 2025
 */

(function() {
  'use strict';
  
  function initCustomNameToggle() {
    // Only run if the second custom name field exists on this product
    const line2Wrapper = document.querySelector('.custom-name-2-wrapper');
    
    if (!line2Wrapper) {
      return; // Exit early if this product doesn't have the second field
    }
    
    // Function to get the currently selected embroidery line option value
    function getSelectedEmbroideryOption() {
      // Try radio buttons first (for button/swatch selectors)
      const checkedRadio = document.querySelector('input[name="Number of Embroidered Lines"]:checked');
      if (checkedRadio) {
        return checkedRadio.value;
      }
      
      // Try dropdown select (for dropdown selectors)
      const dropdown = document.querySelector('select[name="Number of Embroidered Lines"]');
      if (dropdown) {
        return dropdown.value;
      }
      
      // Fallback: check for any select with option containing "Lines"
      const anySelect = document.querySelector('select option[selected]');
      if (anySelect && anySelect.textContent.includes('Lines')) {
        return anySelect.value;
      }
      
      return null;
    }
    
    // Function to toggle the second field visibility
    function toggleSecondField() {
      const selectedValue = getSelectedEmbroideryOption();
      
      if (selectedValue) {
        // Show second field if variant contains "Two Lines", otherwise hide it
        if (selectedValue.includes('Two Lines')) {
          line2Wrapper.style.display = 'block';
        } else {
          line2Wrapper.style.display = 'none';
        }
      }
    }
    
    // Run on initialization to set initial state
    toggleSecondField();
    
    // Listen for changes to radio buttons (for button/swatch selectors)
    const embroideryRadios = document.querySelectorAll('input[name="Number of Embroidered Lines"]');
    embroideryRadios.forEach(function(radio) {
      radio.addEventListener('change', toggleSecondField);
    });
    
    // Listen for changes to dropdown (for dropdown selectors)
    const embroideryDropdown = document.querySelector('select[name="Number of Embroidered Lines"]');
    if (embroideryDropdown) {
      embroideryDropdown.addEventListener('change', toggleSecondField);
    }
    
    // Fallback: Listen to the main variant selector (works for all types)
    const mainVariantSelect = document.querySelector('[name="id"]');
    if (mainVariantSelect) {
      mainVariantSelect.addEventListener('change', toggleSecondField);
    }
  }
  
  // Run when DOM is ready, or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomNameToggle);
  } else {
    initCustomNameToggle();
  }
})();
